// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_0tyW5w","left":"KM0vRo","right":"kWMunc"};